import { useNavigatorScroll } from '@/hooks/useNavigatorScroll';
import FastAverageColor, { FastAverageColorResult } from 'fast-average-color';
import { useEffect, useRef, useState } from 'react';
import { FixedNavBar } from '../FixedNavBar';
import cover from '@/assets/img/cover.jpg';
import './headerPlaylist.scss';
export interface IPropsInfoPlaylist {
  scrollTop?: number;
  styleNavBar?: React.CSSProperties;
  image: string;
  name: string;
  color?: {
    colorStart: string;
    colorEnd: string;
    colorObject: FastAverageColorResult;
    colorFixed: string;
  };
  navigation?: React.RefObject<HTMLDivElement>;
  title?: string;
}
export const HeaderPlaylist = ({
  image,
  name,
  navigation,
  title
}: IPropsInfoPlaylist) => {
  const imageValue = useRef<HTMLImageElement>(null);
  const { scrollTop, scrolling } = useNavigatorScroll({ navigation });

  const [color, setColor] = useState({
    colorStart: '',
    colorEnd: '',
    colorFixed: '',
    colorObject: {} as FastAverageColorResult
  });

  const styles: React.CSSProperties = {
    background: `linear-gradient(180deg, rgba(${color.colorStart}) 30%, rgba(${color.colorEnd}) 100%)`
  };

  const styleImg: React.CSSProperties = {
    transform: `scale(${
      scrollTop > 100 && scrollTop < 500 ? (50 / scrollTop) * 2 : 1.02
    }) translateZ(0)`
  };

  const styleNavBar: React.CSSProperties = {
    display: scrolling ? '' : 'none',
    opacity: scrolling ? 1 : 0,
    background: `linear-gradient(215deg, ${color.colorObject.hex} 22%, #3f3c49 100%, #5b173f00 100%)`
  };

  useEffect(() => {
    const initColor = async () => {
      const fac = new FastAverageColor();
      if (!imageValue.current) return;
      const valueColor = await fac.getColorAsync(imageValue.current, {
        algorithm: 'dominant',
        mode: 'precision'
      });
      const colorStart = [...valueColor.value.slice(0, 3), 0.5].join(',');
      const colorEndRgba = [...valueColor.value.slice(0, 3), 0].join(',');
      setColor({
        colorStart,
        colorEnd: colorEndRgba,
        colorObject: valueColor,
        colorFixed: valueColor.value.join(',')
      });
    };
    initColor();

    return () => {
      null;
    };
  }, []);

  return (
    <article className='a-infoPlaylist'>
      <figure className='a-infoPlaylist__img' style={styles}>
        <img
          style={styleImg}
          crossOrigin='anonymous'
          ref={imageValue}
          className='a-infoPlaylist__avatar'
          src={image ? image : cover}
          alt={name}
          onError={({ currentTarget }) => {
            currentTarget.onerror = null; // prevents looping
            currentTarget.src = cover;
          }}
        />
      </figure>
      <FixedNavBar title={title} styleNavBar={styleNavBar} />
    </article>
  );
};
